import {
  DRAFT_ORDER_CREATE_REQUEST,
  DRAFT_ORDER_CREATE_REQUEST_FAILED,
  DRAFT_ORDER_CREATE_REQUEST_SUCCESS,
  DRAFT_ORDER_UPDATE_REQUEST,
  DRAFT_ORDER_UPDATE_REQUEST_FAILED,
  DRAFT_ORDER_UPDATE_REQUEST_SUCCESS,
  FETCH_DRAFT_ORDERS_REQUEST,
  FETCH_DRAFT_ORDERS_REQUEST_FAILED,
  FETCH_DRAFT_ORDERS_REQUEST_SUCCESS,
  DRAFT_ORDER_COMPLETE_REQUEST,
  DRAFT_ORDER_COMPLETE_REQUEST_FAILED,
  DRAFT_ORDER_COMPLETE_REQUEST_SUCCESS,
  DRAFT_ORDER_DELETE_REQUEST_SUCCESS,
} from '../types'

const initialState = {
  isLoading: true,
  isCreating: false,
  isUpdating: false,
  byId: {},
  byCustomerId: {},
}

const reducers = {}

reducers[DRAFT_ORDER_CREATE_REQUEST] = state => {
  return Object.assign({}, state, {
    isCreating: true,
  })
}

reducers[FETCH_DRAFT_ORDERS_REQUEST] = state => {
  return Object.assign({}, state, {
    isLoading: true,
  })
}

reducers[DRAFT_ORDER_CREATE_REQUEST_FAILED] = state => {
  return Object.assign({}, state, {
    isLoading: false,
    isCreating: false,
  })
}

reducers[FETCH_DRAFT_ORDERS_REQUEST_FAILED] = state => {
  return Object.assign({}, state, {
    isLoading: false,
  })
}

const buildLineItem = item => {
  let discount
  if (item.appliedDiscount) {
    discount = {
      number: item.appliedDiscount.value,
      isPercent: item.appliedDiscount.valueType === 'PERCENTAGE',
    }
  }
  if (item.custom) {
    const quantity = item.quantity || 1
    const price = item.originalUnitPrice * 100
    const newItem = {
      ...item,
      displayName: item.name,
      title: item.name,
      product: {
        name: item.name,
      },
      customPrice: item.originalUnitPrice,
      price: {
        price,
        currency: 'USD',
      },
      total: price * quantity,
    }
    if (discount) newItem.price.discount = discount
    return newItem
  }
  const { variant, product } = item
  const quantity = item.quantity || variant.quantity || 1
  const price = variant.price * 100
  const name = product.hasOnlyDefaultVariant ? item.name : variant.displayName
  const newItem = {
    ...variant,
    variantId: item.id,
    product: {
      name,
      featuredImage: product.featuredImage,
      stock: variant.inventoryQuantity,
      sku: variant.sku,
    },
    price: {
      price,
      currency: 'USD',
    },
    quantity,
    total: price * quantity,
  }
  if (discount) newItem.price.discount = discount
  return newItem
}

reducers[DRAFT_ORDER_CREATE_REQUEST_SUCCESS] = (state, action) => {
  const { payload, meta } = action
  const {
    draftOrderCreate: { draftOrder },
  } = payload
  const {
    requestParameters: { customerId },
  } = meta
  const newById = Object.assign({}, state.byId)

  const newOrder = { ...draftOrder }
  newOrder.lineItems = newOrder.lineItems.edges.map(lineItem =>
    buildLineItem(lineItem.node)
  )

  newById[draftOrder.id] = newOrder

  const newByCustomerId = Object.assign({}, state.byCustomerId)
  newByCustomerId[customerId] = draftOrder.id

  return Object.assign({}, state, {
    isCreating: false,
    byId: newById,
    byCustomerId: newByCustomerId,
  })
}

reducers[FETCH_DRAFT_ORDERS_REQUEST_SUCCESS] = (state, action) => {
  const { payload } = action
  const { draftOrders } = payload
  const newById = Object.assign({}, state.byId)
  const newByCustomerId = Object.assign({}, state.byCustomerId)
  draftOrders.edges.forEach(item => {
    const node = item.node
    const newItem = { ...node }
    newItem.lineItems = node.lineItems.edges.map(lineItem =>
      buildLineItem(lineItem.node)
    )
    newById[node.id] = newItem
  })
  const first = draftOrders.edges[0]
  if (first) {
    const node = first.node
    newByCustomerId[node.customer.id] = node.id
  }

  return Object.assign({}, state, {
    isLoading: false,
    byId: newById,
    byCustomerId: newByCustomerId,
  })
}

reducers[DRAFT_ORDER_UPDATE_REQUEST] = state => {
  return Object.assign({}, state, { isUpdating: true })
}

reducers[DRAFT_ORDER_UPDATE_REQUEST_FAILED] = state => {
  return Object.assign({}, state, { isUpdating: false })
}

reducers[DRAFT_ORDER_UPDATE_REQUEST_SUCCESS] = (state, action) => {
  const { payload } = action
  const {
    draftOrderUpdate: { draftOrder },
  } = payload
  const newById = Object.assign({}, state.byId)

  const newOrder = { ...draftOrder }
  newOrder.lineItems = newOrder.lineItems.edges.map(lineItem =>
    buildLineItem(lineItem.node)
  )

  newById[draftOrder.id] = newOrder

  return Object.assign({}, state, {
    isUpdating: false,
    byId: newById,
  })
}

reducers[DRAFT_ORDER_COMPLETE_REQUEST] = state => {
  return Object.assign({}, state, { isUpdating: true })
}

reducers[DRAFT_ORDER_COMPLETE_REQUEST_FAILED] = state => {
  return Object.assign({}, state, { isUpdating: false })
}

reducers[DRAFT_ORDER_COMPLETE_REQUEST_SUCCESS] = (state, action) => {
  const { payload } = action
  const {
    draftOrderComplete: { draftOrder },
  } = payload
  const newById = Object.assign({}, state.byId)

  delete newById[draftOrder.id]

  return Object.assign({}, state, {
    isUpdating: false,
    byId: newById,
  })
}

reducers[DRAFT_ORDER_DELETE_REQUEST_SUCCESS] = (state, action) => {
  const { payload } = action
  const {
    draftOrderDelete: { deletedId },
  } = payload
  const newById = Object.assign({}, state.byId)

  delete newById[deletedId]

  return Object.assign({}, state, {
    isUpdating: false,
    byId: newById,
  })
}

export default function reducer(state = initialState, action) {
  const found = reducers[action.type]
  if (found) return found(state, action)
  return state
}
